export default __webpack_public_path__ + "static/media/New Project (2).3839b4e2.png";